import { render, staticRenderFns } from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=template&id=a804d2a6&scoped=true"
import script from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=script&lang=js"
export * from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=script&lang=js"
import style0 from "./ExternalEmbeddedSocialMediaInfoSection.vue?vue&type=style&index=0&id=a804d2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a804d2a6",
  null
  
)

export default component.exports